import React from "react";
import { makeStyles } from '@mui/styles';
import { Grid, Theme } from '@mui/material';
import { Dialog, DialogContent, DialogActions, Typography, Button } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  navIcon: {
    color: '#999 !important',
    fontSize: '1.7rem !important',
    fontWeight: '900 !important'
  },
  logo: {
    transition: 'height 0.4s ease 0s, opacity 0.3s ease 0s',
    margin: '0 auto'
  },
  logoHolder: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  paragraph: {
    lineHeight: 1.6,
    color: '#555',
    fontSize: '0.978rem',
    fontStyle: 'normal',
    textAlign: 'left',
    fontWeight: '400',
    marginBottom: '30px'
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '1rem',
    [theme.breakpoints.down('md')]: {
      padding: '0rem',
    },
  },
  linkButton: {
    color: '#fff !important',
    backgroundColor: '#5d307f',
    borderColor: '#5d307f',
    marginLeft: '10px',
    fontWeight: 400,
    whiteSpace: 'nowrap',
    userSelect: 'none',
    border: '1px solid transparent',
    padding: '0.375rem 0.75rem',
    fontSize: '1rem',
    lineHeight: 1.5,
    borderRadius: '0.25rem',
    transition: 'all 0.15s ease-in-out',

    "&:hover": {
      color: '#000 !important',
      backgroundColor: '#e37927',
      borderColor: '#e37927',
    },
  },
  asideInner: {
    padding: '1rem',
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      padding: '1rem',
    },
  }
}));

type Props = {
  transferProcessingActive: boolean;
  transactionProcessingClose: () => void;
  transferProcessingDay2: number;
};

export default function TransferProcessingPopup({ transferProcessingActive, transactionProcessingClose, transferProcessingDay2 }: Props) {
  const classes = useStyles();

  return (
    <Dialog 
      open={transferProcessingActive} 
      onClose={transactionProcessingClose} 
      maxWidth="sm" 
      fullWidth
    >
      <DialogContent className={classes.asideInner}>
        <Typography className={classes.paragraph}>
          <strong>Transfer in process...</strong><br />
          Your international transfer request has been received.<br />
          This may take <strong>{transferProcessingDay2} business day(s)</strong> to complete.
        </Typography>
      </DialogContent>

      <DialogActions className={classes.footer}>
        <Button 
          onClick={transactionProcessingClose} 
          className={classes.linkButton}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
